/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Row,
  Col,
  Input,
} from 'antd';
import LadaNumero from 'components/LadaNumero';
import Select from 'components/Select';

export const tabConfigEntidadPermission = {
  model: 'usuario',
  catalogs: ['moneda'],
};

const Configurations = ({
  disabled: _disabled,
  permission,
  form,
  monedas,
}) => {
  const id = Form.useWatch('id', form);
  // eslint-disable-next-line react/prop-types
  const disabled = _disabled || !(id ? permission.change : permission.add);
  const crearUsuarioAlActivarEmpleado = Form.useWatch('crear_usuario_a_partir_de_un_nuevo_empleado', form);

  const rules = { required: [{ required: true }] };

  return (
    <Col span={24}>
      <Form
        form={form}
        name="configurations"
        layout="vertical"
        scrollToFirstError
        initialValues={{
          requiere_autorizacion_multipaso_nombramientos: true,
          requiere_autorizacion_multipaso_contrataciones: true,
          requiere_autorizacion_multipaso_plazas: true,
        }}
      >
        <Row gutter={10}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Col xs={24} sm={24} md={8}>
            <LadaNumero
              rules={rules}
              disabled={disabled}
              ladaOnly
              form={form}
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              rules={rules.required}
              name="moneda"
              label="Moneda"
              hasFeedback
            >
              <Select
                disabled={disabled}
                dataSource={monedas}
                render={(e) => `${e.codigo_de_la_moneda} - ${e.descripcion}`}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="requiere_autorizacion_multipaso_nombramientos"
              label="Autorización Escalonada de Nombramientos"
              hasFeedback
              rules={rules.required}
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="requiere_autorizacion_multipaso_contrataciones"
              label="Autorización Escalonada de Contrataciones"
              hasFeedback
              rules={rules.required}
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="requiere_autorizacion_multipaso_plazas"
              label="Autorización Escalonada de Plazas"
              hasFeedback
              rules={rules.required}
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="crear_usuario_a_partir_de_un_nuevo_empleado"
              label="¿Crear Usuario Automáticamente al Activar un Empleado?"
              hasFeedback
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          {crearUsuarioAlActivarEmpleado && (
            <>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="formato_del_correo_electronico_nuevo_usuario"
                  label="Formato del Correo del Usuario Autogenerado"
                  tooltip="Placeholders disponibles: {numero_empleado}, {nombre}, {apellido_paterno}, {apellido_materno}, {inicial_nombre}, {inicial_apellido_paterno}"
                >
                  <Input disabled={disabled} placeholder="{numero_empleado}" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="dominio_del_correo_electronico_nuevo_usuario"
                  label="Dominio del Correo Electrónico"
                >
                  <Input disabled={disabled} placeholder="tlajomulco.gob.mx" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="formato_de_contrasena_nuevo_usuario"
                  label="Formato de la Contraseña Inicial"
                  tooltip="Placeholders disponibles: {numero_empleado}, {nombre}, {apellido_paterno}, {apellido_materno}, {inicial_nombre}, {inicial_apellido_paterno}"
                >
                  <Input disabled={disabled} placeholder="{numero_empleado}" />
                </Form.Item>
              </Col>
            </>
          )}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="modo_pruebas_timbrado"
              label="¿Timbrado en Modo de Pruebas?"
              tooltip="Si se activa, el timbrado de nómina usa un RFC fijo del catálogo de pruebas del SAT en lugar del RFC real de la entidad y del empleado. Usar solo en ambientes de prueba, nunca en producción."
              hasFeedback
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="url_servicio_timbrado"
              label="URL del Servicio de Timbrado"
              tooltip="URL del servicio de timbrado masivo de nómina a utilizar, ej. https://cfdi-dev.migob.mx/timbrado/nominaMasiva/<RFC>."
            >
              <Input disabled={disabled} placeholder="https://cfdi-dev.migob.mx/timbrado/nominaMasiva/<RFC>" />
            </Form.Item>
          </Col>
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Row>
      </Form>
    </Col>
  );
};

Configurations.propTypes = {
  disabled: PropTypes.bool,
  permission: PropTypes.shape({}).isRequired,
  form: PropTypes.instanceOf(Form).isRequired,
  monedas: PropTypes.any.isRequired,
};

Configurations.defaultProps = {
  disabled: false,
};

export default Configurations;
